export const TWO_STAGE_ORDERING = 'two_stage_ordering';
export const TEMPO_TAGGED_REVIEWS = 'tempo_tagged_reviews';
export const HUB_REDIRECT = 'hub_redirect';
export const NEW_PAUSED_NO_SUBSCRIPTION = 'new_paused_no_subscription';
export const DORMANT_PAUSED_NO_SUBSCRIPTION = 'dormant_paused_no_subscription';
export const TEMPO_IDME_OFFER2 = 'tempo_idme_offer2';
export const HNE_POST_SAVE_UPSELL = 'hne_post_save_upsell';
